import { render } from "./DanhMucToaXeTable.vue?vue&type=template&id=51f8b4bc&ts=true"
import script from "./DanhMucToaXeTable.vue?vue&type=script&lang=ts"
export * from "./DanhMucToaXeTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__